<template>
    <div class="contact contact-email" :class="`contact-email-${style_class}`">
        <mail-icon size="1x" class="custom-class"></mail-icon>
        <span>info.shop@gmail.com</span>
    </div>
</template>

<script>
    import { MailIcon } from 'vue-feather-icons'

    export default {
        name: "EmailButton",
        props: {
            style_class: {
                type: String,
                default: ''
            }
        },
        components: {
            MailIcon
        }
    };
</script>

<style scoped lang="scss">
    .contact-email {
        cursor: pointer;
    }
</style>
